module.exports = __webpack_public_path__ + "img/fav-prod-2.cde7c2a6.png";